import { supabase } from '../lib/supabase';

export const apiKeyService = {
  async getApiKeys(userId) {
    if (!userId) return { data: [], error: 'User ID required' };
    try {
      if (!supabase) return { data: [], error: 'Database not available' };
      const { data, error } = await supabase
        ?.from('api_keys')
        ?.select('*')
        ?.eq('user_id', userId)
        ?.order('created_at', { ascending: false });
      if (error) {
        console.warn('Error fetching API keys:', error?.message);
        return { data: [], error: error?.message };
      }
      return { data: data || [], error: null };
    } catch (err) {
      console.error('Error in getApiKeys:', err);
      return { data: [], error: err?.message };
    }
  },

  async createApiKey(userId, keyData) {
    if (!userId) return { data: null, error: 'User ID required' };
    try {
      if (!supabase) return { data: null, error: 'Database not available' };
      const keyValue = `lgp_${Math.random()?.toString(36)?.substring(2)}${Date.now()?.toString(36)}`;
      const { data, error } = await supabase
        ?.from('api_keys')
        ?.insert([{
          user_id: userId,
          name: keyData?.name || 'API Key',
          key_value: keyValue,
          permissions: keyData?.permissions || ['read'],
          is_active: true,
          expires_at: keyData?.expires_at || null,
          created_at: new Date()?.toISOString(),
          updated_at: new Date()?.toISOString()
        }])
        ?.select()
        ?.single();
      if (error) throw error;
      return { data, error: null };
    } catch (err) {
      console.error('Error creating API key:', err);
      return { data: null, error: err?.message };
    }
  },

  async revokeApiKey(keyId) {
    if (!keyId) return { success: false, error: 'Key ID required' };
    try {
      if (!supabase) return { success: false, error: 'Database not available' };
      const { error } = await supabase
        ?.from('api_keys')
        ?.update({ is_active: false, updated_at: new Date()?.toISOString() })
        ?.eq('id', keyId);
      if (error) throw error;
      return { success: true, error: null };
    } catch (err) {
      console.error('Error revoking API key:', err);
      return { success: false, error: err?.message };
    }
  },

  async deleteApiKey(keyId) {
    if (!keyId) return { success: false, error: 'Key ID required' };
    try {
      if (!supabase) return { success: false, error: 'Database not available' };
      const { error } = await supabase
        ?.from('api_keys')
        ?.delete()
        ?.eq('id', keyId);
      if (error) throw error;
      return { success: true, error: null };
    } catch (err) {
      console.error('Error deleting API key:', err);
      return { success: false, error: err?.message };
    }
  },

  async getUsageStats(userId) {
    if (!userId) return { data: null, error: 'User ID required' };
    try {
      if (!supabase) return { data: null, error: 'Database not available' };
      const { data, error } = await supabase
        ?.from('api_keys')
        ?.select('id, name, usage_count, last_used_at, is_active')
        ?.eq('user_id', userId);
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (err) {
      console.error('Error fetching usage stats:', err);
      return { data: [], error: err?.message };
    }
  }
};

export default apiKeyService;